import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import Handlebars from "handlebars";
import Vue from "vue";
export const scapeMarkup = markup => new Handlebars.SafeString(markup);
export const scapeMarkupWithValue = markup => {
  const {
    userDetails: {
      givenName,
      familyName
    }
  } = Vue.auth.session.get();
  if (_includesInstanceProperty(markup).call(markup, "{{givenName}}")) markup = markup.replace("{{givenName}}", $.safeString(givenName));
  if (_includesInstanceProperty(markup).call(markup, "{{familyName}}")) markup = markup.replace("{{familyName}}", $.safeString(familyName));
  return new Handlebars.SafeString(markup);
};
export const activityAnchor = (accountDetails, type, metadata) => {
  const {
    clientUsername,
    agentUsername
  } = accountDetails;
  const {
    docType,
    applicationId
  } = metadata;
  let {
    accountType
  } = Vue.auth.session.get().accountDetails;
  if (accountType === "agent") accountType = "broker";
  const types = {
    "new-client-signup": {
      text: "",
      href: {}
    },
    "document-uploaded": {
      text: "View document",
      href: {
        client: `#/documents?docType=${docType}`,
        broker: applicationId ? `#/clients/applications/${clientUsername}?tab=documents&docType=${docType}&agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "requested-documents": {
      text: "View documents",
      href: {
        client: "#/documents",
        broker: applicationId ? `#/clients/applications/${clientUsername}?tab=documents&agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "marked-document-complete": {
      text: "View document",
      href: {
        client: `#/documents?docType=${docType}`,
        broker: applicationId ? `#/clients/applications/${clientUsername}?tab=documents&docType=${docType}&agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "marked-document-outstanding": {
      text: "View document",
      href: {
        client: `#/documents?docType=${docType}`,
        broker: applicationId ? `#/clients/applications/${clientUsername}?tab=documents&docType=${docType}&agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "application-changed": {
      text: "See application",
      href: {
        client: "#/mortgage-application",
        broker: applicationId ? `#/clients/applications/${clientUsername}?agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "application-submitted": {
      text: "See application",
      href: {
        client: "#/mortgage-application",
        broker: applicationId ? `#/clients/applications/${clientUsername}?agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "comment-added-to-document": {
      text: "View Documents",
      href: {
        client: `#/documents?docType=${docType}`,
        broker: applicationId ? `#/clients/applications/${clientUsername}?tab=documents&docType=${docType}&agentUsername=${agentUsername}&applicationId=${applicationId}` : `#/clients/applications?clientUsername=${clientUsername}`
      }
    },
    "reminder-added": {
      text: "View Note",
      href: {
        broker: `#/clients/board/${clientUsername}`
      }
    }
  };
  const {
    text,
    href
  } = types[type];
  return new Handlebars.SafeString(`<a class ="view-comment bold" href="${href[accountType]}">${text}</a>`);
};
export const clientProfileActivityAnchor = activty => {
  let href;
  const label = {
    "follow-ups": "View follow up",
    notes: "View note"
  };
  if (_includesInstanceProperty(activty).call(activty, "Follow up")) {
    href = "follow-ups";
  } else {
    href = "notes";
  }
  return new Handlebars.SafeString(`<a class="view-comment bold property-link" href="${href}">${label[href]}</a>`);
};
export const campaignResultsTooltip = isEnabled => {
  const title = "This campaign has not been sent, hence there are no results for it";
  if (isEnabled) return new Handlebars.SafeString(`data-toggle="tooltip" data-placement="right" title="${title}"`);
};
export const tooltip = (settingsOverrides, target) => {
  const options = {
    overrideForm: "Your brokerage has opted to override application form customizations.",
    overrideFaq: "Your brokerage has opted to override FAQ customizations.",
    overrideStyle: "Your brokerage has opted to override style customizations."
  };
  const title = options[target];
  if (settingsOverrides[target] === true) return new Handlebars.SafeString(`data-toggle="tooltip" data-placement="bottom" title="${title}"`);
};
export const planTooltip = (session, type, position) => {
  if (position.data) position = "bottom"; //if handlebars obj
  if (!position) position = "bottom";
  const {
    permissions
  } = session;
  if (permissions[type] !== "write") {
    const title = "This option is only available in Expert Pro plan";
    return new Handlebars.SafeString(`data-toggle="tooltip" data-placement="${position}" title="${title}"`);
  }
};
export const subscribedBadge = ({
  subscribed,
  source,
  email,
  emailId
}) => {
  const text = subscribed ? "Subscribed" : "Unsubscribed";
  const disabled = source === "application" && !subscribed ? "disabled" : "";
  const tooltip = disabled || !subscribed ? `data-toggle="tooltip" data-boundary="viewport" data-placement="top" data-original-title="User cannot be re-subscribed"` : "";
  return new Handlebars.SafeString(`
      <div ${tooltip} class="marketing-badge-wrapper" tabindex="0">
      <div data-email="${email}" data-email-id="${emailId}" data-source="${source}" data-subscribed="${subscribed}" class="clickable marketing-badge subscribed ${disabled} ${subscribed} ${subscribed ? "" : "disabled"} w-100">
        <a class="marketing-badge-content ${disabled}">${text}</a>
      </div>
      </div>`);
};
export const registerHandlebarHelpers = _Handlebars => {
  _Handlebars.registerHelper("scapeMarkup", markup => new _Handlebars.SafeString(markup));
  _Handlebars.registerHelper("scapeMarkupWithValue", scapeMarkupWithValue);
  _Handlebars.registerHelper("activityAnchor", activityAnchor);
  _Handlebars.registerHelper("clientProfileActivityAnchor", clientProfileActivityAnchor);
  _Handlebars.registerHelper("campaignResultsTooltip", campaignResultsTooltip);
  _Handlebars.registerHelper("tooltip", tooltip);
  _Handlebars.registerHelper("planTooltip", planTooltip);
  _Handlebars.registerHelper("subscribedBadge", subscribedBadge);
};